import React from "react";
import { Link } from "@mui/material";
import { useEmbeddedExitConfirm } from "../../hooks/useEmbeddedExitConfirm";
import EmbeddedExitConfirmDialog from "../modals/EmbeddedExitConfirmDialog";

export default function ExternalLink({
  href,
  target,
  children,
  onClick,
  ...props
}) {
  const {
    dialogOpen,
    handleConfirm,
    handleCancel,
    createClickHandler,
    brandName,
    storagePrefix,
  } = useEmbeddedExitConfirm();

  const handleClick = createClickHandler(href, target, onClick);

  return (
    <>
      <Link href={href} target={target} onClick={handleClick} {...props}>
        {children}
      </Link>
      <EmbeddedExitConfirmDialog
        open={dialogOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        brandName={brandName}
        storagePrefix={storagePrefix}
      />
    </>
  );
}
